import { Dialog, DialogContent, DialogHeader, DialogTitle } from '../ui/dialog';
import { Crown, Loader2 } from 'lucide-react';
import { contactStatusLabel } from './AdminContactsList';

export function AdminUserDetailModal({ open, onOpenChange, loading, detail }) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="bg-card border-border max-w-2xl max-h-[80vh] overflow-y-auto">
        <DialogHeader>
          <DialogTitle>Détails utilisateur</DialogTitle>
        </DialogHeader>
        {loading ? (
          <div className="flex items-center justify-center py-8">
            <Loader2 className="w-6 h-6 animate-spin text-primary" />
          </div>
        ) : detail ? (
          <div className="space-y-5">
            <UserInfoCard user={detail.user} studentsCount={detail.students_count} />
            <QuizzesList quizzes={detail.quizzes} />
            <ResultsList results={detail.results} />
            {detail.contact_requests?.length > 0 && (
              <ContactRequestsList requests={detail.contact_requests} />
            )}
          </div>
        ) : null}
      </DialogContent>
    </Dialog>
  );
}

function UserInfoCard({ user, studentsCount }) {
  return (
    <div className="flex items-center gap-4 bg-secondary/50 rounded-lg p-4">
      {user?.picture ? (
        <img src={user.picture} alt="" className="w-12 h-12 rounded-full" />
      ) : (
        <div className="w-12 h-12 rounded-full bg-primary/20 flex items-center justify-center text-lg font-bold text-primary">
          {user?.name?.[0]}
        </div>
      )}
      <div>
        <p className="font-bold text-lg">{user?.name}</p>
        <p className="text-sm text-muted-foreground">{user?.email}</p>
        <div className="flex items-center gap-2 mt-1">
          {user?.status === 'abonne' ? (
            <span className="inline-flex items-center gap-1 px-2 py-0.5 text-xs font-bold rounded-full bg-amber-400/10 text-amber-400 border border-amber-400/30">
              <Crown className="w-3 h-3" /> Pro
            </span>
          ) : (
            <span className="inline-flex items-center px-2 py-0.5 text-xs rounded-full bg-secondary text-muted-foreground border border-border">
              Gratuit
            </span>
          )}
          <span className="text-xs text-muted-foreground">{studentsCount} élèves</span>
        </div>
      </div>
    </div>
  );
}

function QuizzesList({ quizzes }) {
  return (
    <div>
      <h3 className="text-sm font-bold uppercase tracking-wider text-muted-foreground mb-2">
        QCM créés ({quizzes?.length || 0})
      </h3>
      {quizzes?.length > 0 ? (
        <div className="space-y-2">
          {quizzes.map((q) => (
            <div key={q.quiz_id} className="flex items-center justify-between p-3 rounded-lg bg-secondary/30">
              <div>
                <p className="font-medium text-sm">{q.titre}</p>
                <p className="text-xs text-muted-foreground">{q.classe} &middot; {q.questions?.length || 0} questions &middot; /{q.bareme}</p>
              </div>
              <span className="text-xs text-muted-foreground">
                {q.created_at ? new Date(q.created_at).toLocaleDateString('fr-FR') : ''}
              </span>
            </div>
          ))}
        </div>
      ) : (
        <p className="text-sm text-muted-foreground">Aucun QCM</p>
      )}
    </div>
  );
}

function ResultsList({ results }) {
  return (
    <div>
      <h3 className="text-sm font-bold uppercase tracking-wider text-muted-foreground mb-2">
        Derniers résultats ({results?.length || 0})
      </h3>
      {results?.length > 0 ? (
        <div className="space-y-2">
          {results.slice(0, 10).map((r) => (
            <div key={r.result_id} className="flex items-center justify-between p-3 rounded-lg bg-secondary/30">
              <div>
                <p className="font-medium text-sm">{r.student_name}</p>
                <p className="text-xs text-muted-foreground">{r.classe}</p>
              </div>
              <span className={`text-lg font-black ${r.note >= 16 ? 'text-emerald-400' : r.note >= 12 ? 'text-blue-400' : r.note >= 10 ? 'text-amber-400' : 'text-red-400'}`}>
                {r.note}/{r.bareme}
              </span>
            </div>
          ))}
        </div>
      ) : (
        <p className="text-sm text-muted-foreground">Aucun résultat</p>
      )}
    </div>
  );
}

function ContactRequestsList({ requests }) {
  return (
    <div>
      <h3 className="text-sm font-bold uppercase tracking-wider text-muted-foreground mb-2">
        Demandes d'abonnement ({requests.length})
      </h3>
      {requests.map((c) => (
        <div key={c.request_id} className="p-3 rounded-lg bg-secondary/30 space-y-1">
          <p className="text-sm">{c.etablissement} &middot; {c.academie}</p>
          {c.message && <p className="text-sm text-muted-foreground italic">"{c.message}"</p>}
          <p className="text-xs text-muted-foreground">
            {c.created_at ? new Date(c.created_at).toLocaleDateString('fr-FR') : ''} &middot; {contactStatusLabel(c.status).label}
          </p>
        </div>
      ))}
    </div>
  );
}
